<template>
  <v-container fluid>
    <v-row>
      <v-col v-for="feature in featureOptions" :key="feature.featureKey" cols="12" md="6">
        <v-card>
          <v-card-title>{{ feature.label }}</v-card-title>
          <v-card-text>
            <v-autocomplete
              v-model="selected[feature.featureKey]"
              :items="activeUsers"
              :item-text="userLabel"
              item-value="id"
              label="User yang dapat mengakses"
              multiple
              chips
              deletable-chips
              clearable
              :loading="saving[feature.featureKey]"
            >
              <template v-slot:item="{ item }">
                <v-list-item-content>
                  <v-list-item-title>{{ userLabel(item) }}</v-list-item-title>
                  <v-list-item-subtitle>{{ item.email }}</v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :loading="saving[feature.featureKey]"
              :disabled="saving[feature.featureKey]"
              @click="save(feature.featureKey)"
            >
              Simpan
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "KasbonAccess",

  data: () => ({
    selected: {},
    saving: {},
  }),

  computed: {
    ...mapState("user", ["users"]),
    ...mapState("kasbonAccess", ["settings"]),
    featureOptions() {
      return this.settings;
    },
    activeUsers() {
      return this.users.filter(user => !user.isAccountLocked);
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      try {
        await Promise.all([
          this.$store.dispatch("user/getAll"),
          this.$store.dispatch("kasbonAccess/getSettings"),
        ]);
        this.syncSelections();
      } catch (error) {
        this.$store.dispatch("toast", {
          type: "error",
          message: "Gagal memuat pengaturan akses kasbon",
        });
      }
    },

    syncSelections() {
      const selected = {};
      const saving = {};
      this.settings.forEach(feature => {
        selected[feature.featureKey] = feature.users.map(user => user.id);
        saving[feature.featureKey] = false;
      });
      this.selected = selected;
      this.saving = saving;
    },

    userLabel(user) {
      const name = [user.firstName, user.lastName].filter(Boolean).join(" ");
      return user.email ? name + " (" + user.email + ")" : name;
    },

    async save(featureKey) {
      this.$set(this.saving, featureKey, true);
      try {
        await this.$store.dispatch("kasbonAccess/update", {
          featureKey,
          userIds: this.selected[featureKey] || [],
        });
        this.$store.dispatch("toast", {
          type: "success",
          message: "Pengaturan akses kasbon berhasil disimpan",
        });
      } catch (error) {
        this.$store.dispatch("toast", {
          type: "error",
          message: "Gagal menyimpan pengaturan akses kasbon",
        });
      } finally {
        this.$set(this.saving, featureKey, false);
      }
    },
  },
};
</script>
